module.exports = __webpack_public_path__ + "38d26b88659ba4f2cd6054bd700a46f8.pdf";